(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('visualPageService', visualPageService);

    function visualPageService($http, apiUrl, commonService) {
        var service = {
            get: get
        };

        var visualPageUrl = apiUrl.tsApi + 'visualPage';

        function get(pageSerilNo) {
            var param = {
                pageSerilNo: pageSerilNo,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            return $http.post(visualPageUrl, param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        return service;
    }
})();
